export default __webpack_public_path__ + "static/media/100-assurancehabitation.38e0e956.svg";